import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchProviders } from '../../utilities/api';

export const fetchProvidersList = createAsyncThunk(
  'users/fetchProvidersList', fetchProviders
);

const initialState = {
  isLoading: false,
  treatingPhysician: {
    FirstName: 'James',
    // LastName: '',
    // City: '',
    State: 'CA',
    // ZipCode: '',
    MaxRows: 10
    // GroupingType: "1",

  }
}

const medicalSlice = createSlice({
  name: 'medicalTab',
  initialState,
  reducers: {
    resetTreatingPhysician: (state) => {
      state.treatingPhysician = initialState.treatingPhysician;
    }
  },
  extraReducers: (builder) => {
      builder
          .addCase(fetchProvidersList.pending, (state, action) => {
              state.isLoading = true;
          })
          .addCase(fetchProvidersList.fulfilled, (state, action) => {
              state.isLoading = false;
          })
          .addCase(fetchProvidersList.rejected, (state, action) => {
              state.isLoading = false;
          })
  },
});

export default medicalSlice.reducer;

